import { render, staticRenderFns } from "./BranchesTimesTable.vue?vue&type=template&id=740f2638&"
import script from "./BranchesTimesTable.vue?vue&type=script&lang=js&"
export * from "./BranchesTimesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports